<template>
  <div class="quotationManagement">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="container">
              <template v-if="menuState == 1">
                <div class="list-item">
                  {{ $t.onlineOrder.countryName }}：{{ item.CountryName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.addPeople }}：{{ item.UserName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.createTime }}：{{ item.CreateTime }}
                </div>
                <div class="buttons">
                  <van-button
                    class="warning-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationIntegration(item.FPId)"
                    v-if="!isDistributor()"
                    >{{ $t.onlineOrder.setPointRule }}</van-button
                  >

                  <van-button
                    class="search-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationCustomerDiscount(item.FPId)"
                    v-if="!isDistributor()"
                    >{{ $t.onlineOrder.setPrice }}</van-button
                  >

                  <van-button
                    class="primary-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationFreight(item.FPId)"
                    ><span v-if="isDistributor()">{{ $t.onlineOrder.viewPrice }}</span
                    ><span v-else>{{ $t.meta.editButton }}</span></van-button
                  >

                  <van-button
                    class="danger-btn"
                    size="small"
                    type="primary"
                    @click="dialogDeleteShow(item.FPId)"
                    v-if="!isDistributor()"
                    >{{ $t.meta.delete }}</van-button
                  >
                </div>
              </template>
              <template v-if="menuState == 2">
                <div class="list-item">
                  {{ $t.onlineOrder.warehouseCode }}：{{ item.WarehouseCode }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.warehouseName }}：{{ item.WarehouseNameSn }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.warehouseAddress }}：{{ item.WarehouseAddress }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.contact }}：{{ item.WarehouseContact1 }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.companyName }}：{{ item.CompanyName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.state }}：{{ item.WarehouseStateStr }}
                </div>
                <div class="buttons">
                  <van-button
                    :class="item.WarehouseState == '1' ? 'default-btn' : 'search-btn'"
                    size="small"
                    type="primary"
                    @click="editWarehouseState(item)"
                  >
                    <span v-if="item.WarehouseState == '1'">{{ $t.meta.disable }}</span>
                    <span v-else>{{ $t.meta.enable }}</span></van-button
                  >

                  <van-button
                    class="primary-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationWarehouse(item.WMId)"
                    >{{ $t.meta.editButton }}</van-button
                  >

                  <van-button
                    class="danger-btn"
                    size="small"
                    type="primary"
                    @click="dialogDeleteShow(item.WMId)"
                    >{{ $t.meta.delete }}</van-button
                  >
                </div>
              </template>
              <template v-if="menuState == 3">
                <div class="list-item">
                  {{ $t.onlineOrder.quoUpdateTime }}：{{ item.UpdateTime }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.bjNumber }}：{{ item.BJNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.shippingProductName }}：{{ item.ShippingProductName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.username }}：{{ item.UserName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.state }}：{{ item.BJStateStr }}
                </div>
                <div class="buttons">
                  <van-button
                    :class="item.BJState == '1' ? 'default-btn' : 'search-btn'"
                    size="small"
                    type="primary"
                    @click="editQuotationState(item)"
                  >
                    <span v-if="item.BJState == '1'">{{ $t.meta.disable }}</span>
                    <span v-else>{{ $t.meta.enable }}</span></van-button
                  >

                  <van-button
                    class="primary-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationInformation(item.BJId)"
                    >{{ $t.meta.editButton }}</van-button
                  >

                  <van-button
                    class="danger-btn"
                    size="small"
                    type="primary"
                    @click="dialogDeleteShow(item.BJId)"
                    >{{ $t.meta.delete }}</van-button
                  >
                </div>
              </template>
              <template v-if="menuState == 4">
                <div class="list-item">
                  {{ $t.onlineOrder.supplier }}：{{ item.CompanyName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.area }}：{{ item.RegionName }}
                </div>
                <div class="list-item">{{ $t.meta.country }}：{{ item.CountryName }}</div>
                <div class="list-item">{{ $t.meta.city }}：{{ item.CityName }}</div>
                <div class="list-item">
                  {{ $t.onlineOrder.bcType }}：{{ item.BCName }}
                </div>
                <div class="list-item">{{ $t.onlineOrder.awWay }}：{{ item.AWName }}</div>
                <div class="list-item">
                  {{ $t.onlineOrder.updateTime }}：{{ item.CreateTime }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.serviceState }}：
                  <span v-if="item.QuoteState == 1">{{
                    $t.onlineOrder.serviceState1
                  }}</span>
                  <span v-else>{{ $t.onlineOrder.serviceState2 }}</span>
                </div>
                <div class="buttons">
                  <van-button
                    class="primary-btn"
                    size="small"
                    type="primary"
                    @click="gotoQuotationSupplierCreate(item.SQId)"
                    >{{ $t.meta.editButton }}</van-button
                  >

                  <van-button
                    :class="item.QuoteState == '1' ? 'default-btn' : 'search-btn'"
                    size="small"
                    type="primary"
                    @click="editSupplierQuotationStateBySQId(item)"
                  >
                    <span v-if="item.QuoteState == '1'">{{ $t.meta.disable }}</span>
                    <span v-else>{{ $t.meta.enable }}</span></van-button
                  >
                </div>
              </template>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <template v-if="menuState == 1">
          <van-field
            clickable
            readonly
            :value="countryName"
            :label="$t.onlineOrder.countryName"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showQuotationManagementCountry')"
          />
        </template>
        <template v-if="menuState == 2 || menuState == 3">
          <div class="radio-label">{{ $t.onlineOrder.warehouseStatus }}</div>
          <van-radio-group v-model="warehouseStatus" direction="horizontal">
            <van-radio :name="0">{{ $t.onlineOrder.disableOption }}</van-radio>
            <van-radio :name="1">{{ $t.onlineOrder.enableOption }}</van-radio>
          </van-radio-group>
        </template>
        <template v-if="menuState == 4">
          <div class="radio-label">{{ $t.onlineOrder.serviceState }}</div>
          <van-radio-group v-model="quoteState" direction="horizontal">
            <van-radio :name="1">{{ $t.onlineOrder.serviceState1 }}</van-radio>
            <van-radio :name="0">{{ $t.onlineOrder.serviceState2 }}</van-radio>
          </van-radio-group>

          <van-field
            clickable
            readonly
            :value="areaName"
            :label="$t.onlineOrder.area"
            :placeholder="$t.meta.select"
            @click="pickerShow('showAreaPicker')"
          />

          <van-field
            clickable
            readonly
            :value="countryName"
            :label="$t.onlineOrder.countryName"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showQuotationManagementCountry')"
          />

          <van-field
            clickable
            readonly
            :value="awName"
            :label="$t.onlineOrder.awWay"
            :placeholder="$t.meta.select"
            @click="pickerShow('showAwPicker')"
          />

          <van-field
            clickable
            readonly
            :value="bcName"
            :label="$t.onlineOrder.bcType"
            :placeholder="$t.meta.select"
            @click="pickerShow('showBcPicker')"
          />
        </template>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar" v-if="!isDistributor()">
      <span v-if="menuState == 1">
        <van-button
          type="info"
          block
          @click="gotoQuotationFreight(null)"
          class="submit-button"
          >{{ $t.onlineOrder.addTitle1 }}</van-button
        >
        <van-button class="more-button" @click="handleMoreSheetShow">{{
          $t.meta.more
        }}</van-button>
      </span>

      <van-button
        type="info"
        block
        @click="gotoQuotationWarehouse(null)"
        v-if="menuState == 2"
        >{{ $t.onlineOrder.addTitle2 }}</van-button
      >
      <van-button
        type="info"
        block
        @click="gotoQuotationInformation(null)"
        v-if="menuState == 3"
        >{{ $t.onlineOrder.addTitle3 }}</van-button
      >
      <van-button
        type="info"
        block
        @click="gotoQuotationSupplierCreate(null)"
        v-if="menuState == 4"
        >{{ $t.onlineOrder.addTitle4 }}</van-button
      >
    </div>

    <option-list
      event="showQuotationManagementCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <van-popup v-model="showAwPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.awWay"
        show-toolbar
        :columns="awList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="awConfirm"
        @cancel="showAwPicker = false"
      />
    </van-popup>

    <van-popup v-model="showBcPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.bcType"
        show-toolbar
        :columns="bcList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="bcConfirm"
        @cancel="showBcPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.area"
        show-toolbar
        :columns="areaList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="areaConfirm"
        @cancel="showAreaPicker = false"
      />
    </van-popup>

    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="dialogDeleteConfirm"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  ActionSheet,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(ActionSheet);

export default {
  name: "quotationManagement",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      roleLevel: JSON.parse(localStorage.getItem("auth")).userInfo.RoleLevel,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      countryName: "",
      countryId: null,
      warehouseStatus: null,
      areaName: "",
      areaValue: null,
      awName: "",
      awValue: null,
      bcName: "",
      bcValue: null,
      quoteState: null,
      showFilter: false,
      //多选
      checkedList: [],
      countryList: [],
      areaList: [],
      awList: [],
      bcList: [],
      //picker
      showQuotationManagementCountry: false,
      showAreaPicker: false,
      showAwPicker: false,
      showBcPicker: false,
      //更多
      moreSheetShow: false,
      moreSheetActions: [],
      //删除
      dialogDeleteId: "",
      showDeleteDialog: false,
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {
    if (this.isDistributor()) {
      this.menuList = [
        {
          title: this.$t.onlineOrder.firstTab,
          name: 1,
          count: 0,
        },
      ];
    } else {
      this.menuList = [
        {
          title: this.$t.onlineOrder.firstTab,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.onlineOrder.secondTab,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.onlineOrder.thirdTab,
          name: 3,
          count: 0,
        },
        {
          title: this.$t.onlineOrder.fourthTab,
          name: 4,
          count: 0,
        },
      ];
    }
    this.getOverseasAgentServiceSetting();
    this.getCountryList();
  },
  methods: {
    getOverseasAgentServiceSetting() {
      return new Promise((resolve) => {
        this.$api.supplier
          .getOverseasAgentServiceSetting()
          .then((res) => {
            this.settings = res.data;

            var awList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.AWName,
                value: item.AWId,
              };
              awList.push(data);
            });
            this.awList = this.$commonMethod.deepClone(awList);

            var bcList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.BCName,
                value: item.BCId,
              };
              bcList.push(data);
            });
            this.bcList = this.$commonMethod.deepClone(bcList);

            var areaList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.RegionName,
                value: item.RegionId,
              };
              areaList.push(data);
            });
            this.areaList = this.$commonMethod.deepClone(areaList);

            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    dialogDeleteConfirm() {
      if (this.menuState == 1) {
        this.deleteFreightPrice(this.dialogDeleteId);
      }
      if (this.menuState == 2) {
        this.deleteWarehouseInfo(this.dialogDeleteId);
      }
      if (this.menuState == 3) {
        this.deleteQuotationInfo(this.dialogDeleteId);
      }
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    moreSheetSelect(e) {
      if (e.className == "1") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "quotationCustomerDiscountDetail",
          name: "quotationCustomerDiscountDetail",
          query: [
            {
              name: "Type",
              value: "batch",
            },
            {
              name: "FPId",
              value: this.FPId,
            },
          ],
        });
      }
      this.moreSheetShow = false;
    },
    handleMoreSheetShow() {
      var actions = [];
      actions = [
        {
          name: this.$t.onlineOrder.batchPrice,
          className: "1",
        },
      ];

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    isDistributor() {
      if (this.roleLevel == 4) {
        return true;
      }
      return false;
    },
    getPlaceHolder() {
      if (this.menuState == 1) {
        return this.$t.onlineOrder.cargoCategorySn;
      }
      if (this.menuState == 2) {
        return this.$t.onlineOrder.warehouseSearch;
      }
      if (this.menuState == 3) {
        return this.$t.onlineOrder.quotationNo;
      }
      if (this.menuState == 4) {
        return this.$t.onlineOrder.companyNameKeyword;
      }
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    countryConfirm(e) {
      this.countryName = e.text;
      this.countryId = e.value;
      this.showQuotationManagementCountry = false;
      this.$forceUpdate();
    },
    awConfirm(e) {
      this.awName = e.text;
      this.awValue = e.value;
      this.showAwPicker = false;
    },
    bcConfirm(e) {
      this.bcName = e.text;
      this.bcValue = e.value;
      this.showBcPicker = false;
    },
    areaConfirm(e) {
      this.areaName = e.text;
      this.areaValue = e.value;
      this.showAreaPicker = false;
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    deleteFreightPrice(id) {
      this.$commonMethod.showLoading();
      var param = {
        FPId: id,
      };
      this.$api.onlineOrderManagement
        .deleteFreightPrice(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editQuotationState(item) {
      this.$commonMethod.showLoading();
      var param = {
        BJId: item.BJId,
        BJState: item.BJState == "1" ? 0 : 1,
        UserId: this.UserId,
      };
      this.$api.onlineOrderManagement
        .editQuotationState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteQuotationInfo(id) {
      this.$commonMethod.showLoading();
      var param = {
        BJId: id,
      };
      this.$api.onlineOrderManagement
        .deleteQuotationInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editWarehouseState(item) {
      this.$commonMethod.showLoading();
      var param = {
        WMId: item.WMId,
        WarehouseState: item.WarehouseState == "1" ? 0 : 1,
      };
      this.$api.onlineOrderManagement
        .editWarehouseState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteWarehouseInfo(id) {
      this.$commonMethod.showLoading();
      var param = {
        WMId: id,
      };
      this.$api.onlineOrderManagement
        .deleteWarehouseInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editSupplierQuotationStateBySQId(item) {
      this.$commonMethod.showLoading();
      var param = {
        SQId: item.SQId,
        QuoteState: item.QuoteState == "1" ? 0 : 1,
      };
      this.$api.onlineOrderManagement
        .editSupplierQuotationStateBySQId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoQuotationWarehouse(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationWarehouse",
        name: "quotationWarehouse",
        query: [
          {
            name: "WMId",
            value: id,
          },
        ],
      });
    },
    gotoQuotationInformation(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationInformation",
        name: "quotationInformation",
        query: [
          {
            name: "BJId",
            value: id,
          },
        ],
      });
    },
    gotoQuotationSupplierCreate(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationSupplierCreate",
        name: "quotationSupplierCreate",
        query: [
          {
            name: "SQId",
            value: id,
          },
        ],
      });
    },
    gotoQuotationFreight(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationFreight",
        name: "quotationFreight",
        query: [
          {
            name: "FPId",
            value: id,
          },
          {
            name: "IsView",
            value: this.isDistributor(),
          },
        ],
      });
    },
    gotoQuotationCustomerDiscount(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationCustomerDiscount",
        name: "quotationCustomerDiscount",
        query: [
          {
            name: "FPId",
            value: id,
          },
        ],
      });
    },
    gotoQuotationIntegration(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationIntegration",
        name: "quotationIntegration",
        query: [
          {
            name: "FPId",
            value: id,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.warehouseStatus ||
        this.countryId ||
        this.areaValue ||
        this.awValue ||
        this.bcValue ||
        this.quoteState
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.countryName = "";
      this.countryId = null;
      this.searchText = "";
      this.warehouseStatus = null;
      this.areaName = "";
      this.areaValue = null;
      this.awName = "";
      this.awValue = null;
      this.bcName = "";
      this.bcValue = null;
      this.quoteState = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
      };
      var request = null;
      if (this.menuState == 1) {
        param.CountryId = this.countryId;
        param.CargoCategory = this.searchText;
        request = this.$api.onlineOrderManagement.getFreightPriceListByPage(param);
      }
      if (this.menuState == 2) {
        param.WarehouseState = this.warehouseStatus;
        param.SearchValue = this.searchText;
        request = this.$api.onlineOrderManagement.getWarehouseInfoList(param);
      }
      if (this.menuState == 3) {
        param.State = this.warehouseStatus;
        param.SearchValue = this.searchText;
        request = this.$api.onlineOrderManagement.getQuotationInfoList(param);
      }
      if (this.menuState == 4) {
        param.CountryId = this.countryId;
        param.RegionId = this.areaValue;
        param.BCId = this.bcValue;
        param.AWId = this.awValue;
        param.QuoteState = this.quoteState;
        param.CompanyNameKeyword = this.searchText;
        request = this.$api.onlineOrderManagement.getSupplierQuotationListByPage(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.quotationManagement {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      margin-top: 10px;
      font-size: 12px;
      color: #333;
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          .primary-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .warning-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: #ffba00;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
    .submit-button {
      width: 70%;
      border: none;
      display: inline-block;
    }
    .more-button {
      background: #5029c3;
      color: #fff;
      border: none;
      display: inline-block;
      width: 30%;
    }
  }
}
</style>
